<template>
    <div class="m-definition">
        <div class="m-content">
            <div class="m-slider">
                <slider orientation="X" :auto="false" :controlClick="false">
                    <slider-item v-for="item in sliderArr" :key="item.name">
                        <div class="f-tc m-slider-content">
                            <h1 f-font-PFM s-cr="#323232" class="g-fs32">{{item.name}}</h1>
                            <p f-font-PFR s-cr="#666666" class="g-fs28 f-tj">{{item.value}}</p>
                        </div>
                    </slider-item>
                </slider>
            </div>
            <div class="m-btn" @click="know">知道了</div>
        </div>
    </div>
</template>

<script>
    import Slider from 'ijijin-view/vue/Slider';
    import SliderItem from 'ijijin-view/vue/SliderItem';
    export default {
        name: "definition",
        components: {
            Slider,
            SliderItem
        },
        data() {
            return {
                sliderArr: [{
                    name: 'PE-TTM',
                    value: '指滚动市盈率，是股票价格和每股收益的比率，通常用来衡量股票和指数的估值情况，通常认为PE数值越低，衡量对象的估值越低。'
                },{
                    name: 'PB',
                    value: '指市净率，以最新报告期数据计算的市净率为准，通常认为PB的数据越低，衡量对象的估值越低。'
                },{
                    name: 'PE百分位',
                    value: '指估值历史百分位，表示PE在自身历史区间内所处的相对水平，百分值越低，说明当前指数的相对自身历史的估值水平越低，潜在投资价值越高。'
                },{
                    name: 'PB百分位',
                    value: '指估值历史百分位，表示PB在自身历史区间内所处的相对水平，百分值越低，说明当前指数的相对自身历史的估值水平越低，潜在投资价值越高。'
                },{
                    name: 'ROE',
                    value: '指净资产收益率，用来衡量对象盈利能力的重要指标。'
                }]
            }
        },
        methods: {
            know() {
                this.$emit('definiton')
            }
        }
    }
</script>

<style lang="less" scoped>
.m-definition {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.45);
    z-index: 20;
    .m-content {
        box-sizing: border-box;
        position: absolute;
        width: 558px;
        min-height: 462px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #FFFFFF;
        border-radius: 24px;
        padding: 0 32px 32px;
        .m-slider {
            padding-top: 16px;
            height: 350px;
            /deep/ .vu-slider {
                max-height: 350px!important;
                height: 350px;
                .vu-control-list {
                    .u-icon_il {
                        width: 8px;
                        height: 8px;
                        margin-left: 8px;
                        background: #E6E6E6;
                        &.active {
                            background: #FF330A;
                        }
                    }
                }
            }
            .m-slider-content {
                h1 {
                    line-height: 76px;
                }
                p {
                    line-height: 44px;
                    font-weight: 400;
                }
            }
        }
        .m-btn {
            text-align: center;
            width: 231px;
            height: 80px;
            background: #FF330A;
            border-radius: 16px;
            font-family: PingFangSC-Medium;
            font-size: 28px;
            color: #FFFFFF;
            line-height: 80px;
            font-weight: bold;
            margin: 0 auto;
        }
    }
}
</style>